/* 
Rules.
*/
import moment from "moment";

const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function required(value) {
  return isEmpty(value) ? "Required" : true;
}

export function validDate(
  value,
  dateFormatsAccepted = ["YYYY-MM-DD", "DD MMM YYYY", "DD/MM/YYYY", "D/M/YY"],
  dateFormatForPicker = "YYYY-MM-DD",
  dateMinValue = null,
  dateMaxValue = null
) {
  if (value) {
    const date = moment(value, dateFormatsAccepted);
    let valid = date.isValid();
    if (valid && dateMinValue) {
      valid = date.isAfter(moment(dateMinValue, dateFormatForPicker).subtract(1, "days"));
    }
    if (valid && dateMaxValue) {
      valid = date.isBefore(moment(dateMaxValue, dateFormatForPicker).add(1, "days"));
    }
    if (!valid) {
      return "Invalid date";
    }
  }
  return true;
}

export function validTime(value, timeFormatsAccepted = ["YYYY-MM-DDTHH:mm:ss", "HH:mm", "h:mm A", "HH:mm:ss"]) {
  if (value) {
    const time = moment(value, timeFormatsAccepted);
    return time.isValid() || "Invalid time";
  } else {
    return true;
  }
}

export function email(value) {
  return !value || emailPattern.test(value) || "Invalid email";
}

export function emails(values) {
  if (!values) return true;
  const invalid = [];
  values.split(/[\s,;]+/).forEach(function(part) {
    if (part.length && !emailPattern.test(part)) invalid.push(part);
  });
  const results = invalid.join(", ");
  return results.length ? `Invalid email address${invalid.length === 1 ? "" : "es"}: ${results}` : true;
}
export function greaterThanZero(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return true;
    } else {
      if (getNumber(value) <= 0) {
        return "Value must be greater than zero";
      }
    }
  }
  return true;
}

export function greaterThanZeroPercentage(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return true;
    } else {
      if (getNumber(value) <= 0 || value > 100) {
        return "Value must be greater than zero to 100";
      }
    }
  }
  return true;
}

export function zeroOrGreater(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return true;
    }
    if (getNumber(value) < 0) {
      return "Value must be zero or greater";
    }
  }
  return true;
}

export function betweenZeroAndOne(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return true;
    } else {
      if (getNumber(value) < 0 || getNumber(value) > 1) {
        return "Value must be between zero and one";
      }
    }
  }
  return true;
}

export function percentage(value) {
  if (!isEmpty(value)) {
    if (value < 0 || value > 100) {
      return "Percentage must be between 0 and 100";
    } else if (isNaN(value)) {
      return "Invalid number";
    }
  }
  return true;
}

export function integer(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return "Invalid number";
    } else {
      const n = getNumber(value);
      if (parseInt(n) != n) {
        return "Value must be an integer";
      }
    }
  }
  return true;
}

export function number(value) {
  if (!isEmpty(value)) {
    if (isInvalidNumber(value)) {
      return "Invalid number";
    }
  }
  return true;
}

export function isInvalidNumber(value) {
  if (typeof value === "number") {
    return false;
  }
  if (isEmpty(value)) {
    return false;
  }
  return isNaN(value.replace(/,/g, ""));
}

export function getNumber(value) {
  if (isInvalidNumber(value)) {
    return null;
  }
  if (typeof value === "number" || isEmpty(value)) {
    return value;
  }
  return Number(value.replace(/,/g, ""));
}

export function roundNumber(value, decimalPlaces) {
  const n = getNumber(value);
  if (n != null) {
    return getNumber(n.toFixed(decimalPlaces));
  } else {
    return n;
  }
}

export function isEmpty(value) {
  return value === null || value === undefined || value === "";
}
